<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="10"
        style="max-width: 400px; margin-top: 100px;"
      >
        <SignIn />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SignIn from '../components/auth/SignIn.vue';

export default {
  name: 'SignInPage',
  components: {
    SignIn,
  },
};
</script>
